export default __webpack_public_path__ + "static/media/background.b8db7f8e.jpg";